import classNames from 'classnames'
import style from './style.less'
import Tooltip from '../Tooltip'
import React, { memo, useCallback } from 'react'
import { isActiveRow } from './helpers'
import GridCellText from './GridCellTextElement'

interface GridCellElementProps {
  idx: number
  column: any
  data: any
  i: number
  onRowClick?: (rowIndex: number) => void
}

const GRID_ROW_HOVER_CLASS = 'grid-row-hover'

const GridCellElement = ({
  idx,
  column,
  data,
  i,
  onRowClick,
}: GridCellElementProps) => {
  const isActive = isActiveRow(data, idx)
  const isClickable = Boolean(onRowClick)

  const onMouseOver = useCallback((idx: number) => {
    const row = [...document.querySelectorAll(`.gridItem${idx}`)]
    row.forEach((r) => {
      r.classList.add(style.hoverRow)
      if (isClickable) {
        r.classList.add(GRID_ROW_HOVER_CLASS)
      }
    })
  }, [isClickable])

  const onMouseLeave = useCallback((idx: number) => {
    const row = [...document.querySelectorAll(`.gridItem${idx}`)]
    row.forEach((r) => {
      r.classList.remove(style.hoverRow)
      if (isClickable) {
        r.classList.remove(GRID_ROW_HOVER_CLASS)
      }
    })
  }, [isClickable])

  return (
    <div
      className={classNames(
        style.gridItem,
        'gridItemSelector',
        `gridItem${idx}`,
        style[`gridItem${i}`],
        !isActive ? style.inactive : undefined,
        column.icon ? style.gridItemCenter : undefined,
        isClickable ? style.pointer : undefined
      )}
      onMouseOver={() => onMouseOver(idx)}
      onMouseLeave={() => onMouseLeave(idx)}
      onClick={() => {
        const selection = window.getSelection()
        if (selection?.type !== 'Range') {
          onRowClick?.(idx - 1)
        }
      }}
    >
      {column.tooltip ? (
        <Tooltip
          text={column.tooltip}
          position={i === 0 || i === 1 ? 'right' : 'left'}
        >
          <GridCellText column={column} />
        </Tooltip>
      ) : (
        <GridCellText column={column} />
      )}
    </div>
  )
}

export default memo(GridCellElement)
